"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultThemeProvider = exports.defaultTheme = exports.fonts = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var colors_1 = require("../util/colors");
var config_1 = require("../util/config");
exports.fonts = {
    h1: 'MaisonNeueExtended',
    heading: 'MaisonNeue',
    body: 'MaisonNeue',
};
exports.defaultTheme = {
    typography: {
        baseSize: 1,
        headingType: exports.fonts.heading,
        baseType: exports.fonts.body,
        h1: exports.fonts.h1,
    },
    colors: {
        primary: colors_1.colors.primary700,
        primaryMid: colors_1.colors.primary600,
        primaryDark: colors_1.colors.primary900,
        primaryLight: colors_1.colors.primary200,
        primaryLightest: colors_1.colors.primary100,
        error: colors_1.colors.red400,
        errorLightest: colors_1.colors.red50,
        white: colors_1.colors.white,
        black: colors_1.colors.black,
        gray: colors_1.colors.gray400,
        grayLight: colors_1.colors.gray50,
        grayLightest: colors_1.colors.gray10,
        text: colors_1.colors.gray950,
        textDisabled: colors_1.colors.gray200,
        grayBorder: colors_1.colors.gray100,
        border: colors_1.colors.gray100,
    },
};
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  * {\n    box-sizing: border-box;\n  }\n\n  *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-family: ", ";\n  }\n"], ["\n  * {\n    box-sizing: border-box;\n  }\n\n  *:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-family: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.baseType;
});
var DefaultThemeProvider = function (_a) {
    var theme = _a.theme, config = _a.config, children = _a.children;
    var _b = (0, react_1.useState)(config), chocolatesConfig = _b[0], setConfig = _b[1];
    (0, react_1.useEffect)(function () {
        setConfig(function (c) { return (__assign(__assign({}, c), config)); });
    }, [config]);
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: __assign(__assign({}, exports.defaultTheme), theme) },
        react_1.default.createElement(config_1.ChocolatesContext.Provider, { value: __assign(__assign(__assign({}, config_1.defaultConfig), chocolatesConfig), { setConfig: setConfig }) },
            react_1.default.createElement(Wrapper, null, children))));
};
exports.DefaultThemeProvider = DefaultThemeProvider;
var templateObject_1;
//# sourceMappingURL=theme.js.map